import type { InventoryDto } from "@/api/dtos";
import { INVENTORY_STATUSES } from "../_models/Inventory";
import type { Inventory, InventoryStatus } from "../_models/Inventory";

const toInventoryStatus = (value: string | null): InventoryStatus | null => {
  return INVENTORY_STATUSES.find((status) => status === value) ?? null;
};

/** DTO → domain for one inventory row. */
export const toInventoryFromInventoryDto = (dto: InventoryDto): Inventory => {
  return {
    id: dto.id,
    status: toInventoryStatus(dto.status),
    sku: dto.product.sku,
    productName: dto.product.name,
    locationId: dto.location.id,
    locationName: dto.location.name,
    levels: dto.levels.map((level) => ({
      system: level.system,
      onHand: level.onHand,
      available: level.available,
      allocated: level.allocated,
      onOrder: level.onOrder,
      inTransit: level.inTransit,
      asOf: level.asOf,
      syncedAt: level.syncedAt,
    })),
  };
};
